import { APP_BASE_HREF } from '@angular/common';
import { Component, EventEmitter, Inject, Input, Output } from '@angular/core';
import { QueuesService } from '@app/_core/services/queues.service';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-message-dialog',
  templateUrl: './message-dialog.component.html',
  styleUrl: './message-dialog.component.scss'
})
export class MessageDialogComponent {
  @Input() message:String;
  @Input() name: String;
  @Input() email: String;
  @Input() isUnsubmittedCase: boolean=false;
  @Input() showIcon:boolean=true;
  @Output() isProceed = new EventEmitter<boolean>(false);
  constructor(
      public bsModalRef: BsModalRef,
      private modalService: BsModalService,
      @Inject(APP_BASE_HREF) public baseHref: string,
      public queueServices: QueuesService,
    ) {}
  
    ngOnInit(): void {
      console.log('show-message');
    }
  
    close() {
      this.bsModalRef.hide();
      this.queueServices.SetUnsubmittedCaseForReadonly(false);
    }

    proceed(){
      this.bsModalRef.hide();
      this.isProceed.emit(true);
    }

    ngOnDestroy() {
      // this.modalService.onHide.unsubscribe();
    }
}
